import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root'})
export class SessionTimeoutCountDown {
    remainingSeconds$ = new BehaviorSubject<number>(environment.sessionExpWarningTime);
}